// 组件管理器，用于加载和管理组件配置
import ComponentRenderer from './ComponentRenderer';

class ComponentManager {
  constructor() {
    this.components = new Map();
    this.loaded = false;
  }

  // 加载组件配置文件
  async loadComponents() {
    try {
      // 从components-config目录加载所有组件配置
      const componentModules = await Promise.all([
        import('../components-config/title.js'),
        import('../components-config/info.js'),
        import('../components-config/hanzizitie.js'),
        import('../components-config/container.js'),
        import('../components-config/arithmetic.js'),
        import('../components-config/pinyin.js')
      ]);

      // 注册组件
      componentModules.forEach(module => {
        const config = module.default;
        console.log('加载组件配置', config);
        this.registerComponent(config);
        
        // 注册组件渲染器
        if (config.renderHtml) {
          ComponentRenderer.registerRenderer(config.name, {
            renderHtml: config.renderHtml,
            renderStyle: config.renderStyle
          });
        }
      });

      this.loaded = true;
      console.log('组件配置加载成功', this.components);
      console.log('组件数量', this.components.size);
      
      // 注入所有组件样式
      ComponentRenderer.injectAllStyles();
    } catch (error) {
      console.error('组件配置加载失败', error);
    }
  }

  // 注册单个组件
  registerComponent(config) {
    if (!config || !config.name) {
      console.error('无效的组件配置', config);
      return;
    }

    // 处理组件继承
    if (config.inherit) {
      const parentConfig = this.components.get(config.inherit);
      if (parentConfig) {
        // 合并继承属性
        config = this.mergeComponentConfigs(parentConfig, config);
      }
    }

    this.components.set(config.name, config);
  }

  // 合并组件配置（处理继承关系）
  mergeComponentConfigs(parent, child) {
    return {
      ...parent,
      ...child,
      properties: {
        ...parent.properties,
        ...child.properties
      },
      drawing: {
        ...parent.drawing,
        ...child.drawing,
        props: {
          ...parent.drawing?.props,
          ...child.drawing?.props
        }
      },
      events: {
        ...parent.events,
        ...child.events
      }
    };
  }

  // 获取所有组件配置
  getAllComponents() {
    return Array.from(this.components.values());
  }

  // 根据名称获取组件配置
  getComponent(name) {
    return this.components.get(name);
  }

  // 创建组件实例
  createComponentInstance(componentName, initialProps = {}) {
    const componentConfig = this.getComponent(componentName);
    if (!componentConfig) {
      return null;
    }

    // 生成唯一ID
    const id = `component_${Date.now()}_${Math.floor(Math.random() * 1000)}`;

    // 合并默认属性和初始属性
    const props = {
      // 添加基础参数默认值，这些会被组件配置中的默认值覆盖
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      backgroundColor: 'transparent',
      // 组件配置中的默认值，会覆盖上面的基础默认值
      ...this.getDefaultProps(componentConfig),
      // 初始属性，会覆盖所有默认值
      ...initialProps
    };

    // 创建组件实例
    const instance = {
      id,
      componentName,
      type: componentConfig.drawing?.type || 'rectangle',
      x: 100,
      y: 100,
      props: {
        ...props,
        display: props.display || 'block' // 默认块元素
      },
      properties: componentConfig.properties || {},
      events: componentConfig.events || {},
      children: [], // 添加子组件数组
      selected: false,
      createdAt: Date.now()
    };

    return instance;
  }

  // 获取组件默认属性
  getDefaultProps(componentConfig) {
    const defaultProps = {};
    if (componentConfig.properties) {
      Object.keys(componentConfig.properties).forEach(key => {
        defaultProps[key] = componentConfig.properties[key].default;
      });
    }
    return defaultProps;
  }
}

// 导出单例实例
export default new ComponentManager();